import { memo } from 'react';

const homogenise = o => {
    if (typeof o === 'string' || typeof o === 'number') return o;

    try {
        return JSON.stringify(o);
    } catch(error) {
        return o;
    }
};

export const withExplicitProps = (Component, props) => {
    let d = memo(Component, (prevProps, nextProps) => !props.some(p => homogenise(prevProps[p]) !== homogenise(nextProps[p])));
    Object.defineProperty(d, 'displayName', {
        get: () => Component.displayName,
        set(v) {
            Component.displayName = v;
        }
    });
    return d;
};

export const withNoProps = (Component) => {
    let d = memo(Component, () => true);
    Object.defineProperty(d, 'displayName', {
        get: () => Component.displayName,
        set(v) {
            Component.displayName = v;
        }
    });
    return d;
};

